import appApi from '@/api/app';
import axios from "axios";

export function fileUpload(fd, params = {}, forceLocal = false) {
  if (!forceLocal) {
    return uploadExpand(fd)
  }

  return appApi.upload(fd)
}

export async function uploadExpand(fd, params = {}, config = {}) {
  const file = fd.get('file')
  const {data: siteConfig} = await appApi.getOssConfig({name: file.name})
  const fileKey = siteConfig.key

  fd.append('key', fileKey)
  fd.append('Expires', siteConfig.expire)
  fd.append('OSSAccessKeyId', siteConfig.id)
  fd.append('Signature', siteConfig.signature)
  fd.append('policy', siteConfig.policy)

  // 接口要求file排在最后
  fd.delete('file')
  fd.append('file', file)
  return new Promise((resolve, reject) => {
    axios
      .post(siteConfig.OSSAddress, fd)
      .then(res => {
        const fileUrl = '/' + fileKey
        resolve({
          code: 1,
          data: {
            file: {
              full_url: siteConfig.OSSAddress + fileUrl,
              url: fileUrl,
            },
          },
          msg: '',
          time: Date.now(),
        });
      })
      .catch(err => {
        console.error('上传oss失败:', err);
        reject(err.data);
      });
  });
}



// WEBPACK FOOTER //
// ./src/units/upload.js